import Axios from "axios";
import {
    SET_INV_REQUISITION_LIST,
    UNSET_INV_REQUISITION_LIST,
    SET_INV_DUE_REQUISITION_LIST,
    UNSET_INV_DUE_REQUISITION_LIST,
  } from "@/store/mutation-types";
import {saveInvUpdateRequisition, getInvRequisitionList , getInvDueRequisitionList, getInvRequisitionById as getInvRequisitionByIdApi, getInvDueRequisitionById } from "@/store/api";
// initial state
const state = {
  getInvRequisitionList: [],
  getInvDueRequisitionList: [],
  editingInvRequisition: null,
};

const getters = {
  getInvRequisitionList(state) {
    return state.getInvRequisitionList;
  },
  getInvDueRequisitionList(state) {
    return state.getInvDueRequisitionList;
  },
  // getEditingRequisition: (state) => { 
  //   return state.editingRequisition;
  // },
};

const mutations = {
  [SET_INV_REQUISITION_LIST](state, data) {
    state.getInvRequisitionList = data;
  },
  [UNSET_INV_REQUISITION_LIST](state) {
    state.getInvRequisitionList = [];
  },
  [SET_INV_DUE_REQUISITION_LIST](state, data) {
    state.getInvDueRequisitionList = data;
  },
  [UNSET_INV_DUE_REQUISITION_LIST](state) {
    state.getInvDueRequisitionList = [];
  },
  setEditingRequisition(state, requisition) {
    state.editingRequisition = requisition;
  },
};

const actions = {
  saveInvUpdateRequisition({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveInvUpdateRequisition, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getInvRequisitionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getInvRequisitionList, data)
        .then(function (response) {
          commit('SET_INV_REQUISITION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INV_REQUISITION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvDueRequisitionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getInvDueRequisitionList, data)
        .then(function (response) {
          commit('SET_INV_DUE_REQUISITION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_INV_DUE_REQUISITION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvRequisitionById({ commit }, id) {
    const getInvRequisitionById = `${getInvRequisitionByIdApi}/${id}`;
    return new Promise((resolve, reject) => {
      Axios.post(getInvRequisitionById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getInvDueRequisitionById({ commit }, id) {
    const getInvDuesRequisitionById = `${getInvDueRequisitionById}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getInvDuesRequisitionById)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always)=> {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
